import React from 'react';
import img from '../../images/404.jpg'

const Error = () => {
    return (
        <div>
            <img src={img} className="w-100" alt="" />
        </div>
    );
};

export default Error;